import { render, staticRenderFns } from "./device_types.vue?vue&type=template&id=49165070&scoped=true&"
import script from "./device_types.vue?vue&type=script&lang=js&"
export * from "./device_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49165070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49165070')) {
      api.createRecord('49165070', component.options)
    } else {
      api.reload('49165070', component.options)
    }
    module.hot.accept("./device_types.vue?vue&type=template&id=49165070&scoped=true&", function () {
      api.rerender('49165070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/device_types.vue"
export default component.exports